<template>
    <div>
        <rkm-area
            no-margin-top
            show-legend
        >
            <template slot="leading">
                <rkm-button
                    @click="$refs.Modal.open()"
                    color="primary"
                >
                    Adicionar encaminhamento
                </rkm-button>
            </template>

            <rkm-row>
                <rkm-col cols="12">
                    <List :data="data" />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import List from './List'
import Modal from './Modal'

export default {
    components: {
        List,
        Modal,
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>